module.exports = __webpack_public_path__ + "static/img/Glenferrie-Hotel.eea4434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Glenferrie-Hotel.jpg
// module id = gL4u
// module chunks = 0